<div class="app-rating">
  <div class="rating-source">
    <p>TrustPilot</p>
  </div>
  <div class="rating">
    @for (star of starArray; track $index) {
      <div><i class="{{ star }} star"></i></div>
    }
    @if (rating > 0) {
      <span class="numeric-rating">{{ rating }} out of 5</span>
    }
  </div>
</div>